/* WELLA cart tools: cart share (/cart?ws=<variant>:<qty>,... fills the recipient's cart) and the offers meter refresh. */
(() => {
  if (window.__wellaCartShare) return;
  window.__wellaCartShare = true;

  const PARAM = 'ws';
  const MAX_LINES = 30;
  const MAX_QTY = 10;
  const NOTICE_KEY = 'wella_ws_notice';
  const root = window.Shopify?.routes?.root || '/';
  const MESSAGE = 'شوفي اختياراتي من WELLA 🤍\nافتحي اللينك والقطع هتتحط في سلتك على طول، ضيفي اللي يعجبك ونطلبهم مع بعض 👇';

  const safeSession = {
    get(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } },
    set(key, value) { try { sessionStorage.setItem(key, value); } catch (e) {} },
    remove(key) { try { sessionStorage.removeItem(key); } catch (e) {} },
  };

  function toast(text, ms = 4000) {
    let el = document.querySelector('.wella-ws-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'wella-ws-toast';
      el.setAttribute('role', 'status');
      el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;max-width:min(92vw,420px);padding:12px 18px;border-radius:12px;background:#222;color:#fff;font-size:14px;line-height:1.6;text-align:center;direction:rtl;white-space:pre-line;word-break:break-all;user-select:text;box-shadow:0 6px 24px rgba(0,0,0,.25);transition:opacity .3s';
      document.body.appendChild(el);
    }
    el.textContent = text;
    el.style.opacity = '1';
    clearTimeout(el._t);
    if (ms) el._t = setTimeout(() => { el.style.opacity = '0'; }, ms);
    return el;
  }

  /* ---------- sender ---------- */

  function copyText(text) {
    if (navigator.clipboard?.writeText) {
      return navigator.clipboard.writeText(text).catch(() => legacyCopy(text));
    }
    return legacyCopy(text);
  }

  function legacyCopy(text) {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
    document.body.appendChild(area);
    area.select();
    let ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    area.remove();
    return ok ? Promise.resolve() : Promise.reject(new Error('copy failed'));
  }

  function shareUrl(items, channel) {
    const url = new URL(root + 'cart', location.origin);
    url.searchParams.set(PARAM, items);
    url.searchParams.set('utm_source', 'cart_share');
    url.searchParams.set('utm_medium', channel);
    return url.toString();
  }

  function refreshShareData() {
    const wraps = document.querySelectorAll('[data-wella-cart-share]');
    if (!wraps.length) return;
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((cart) => {
        wraps.forEach((wrap) => {
          const wrapId = Number(wrap.dataset.wrapId || 0);
          const counts = new Map();
          cart.items.forEach((item) => {
            if (item.product_id === wrapId) return;
            counts.set(item.variant_id, (counts.get(item.variant_id) || 0) + item.quantity);
          });
          const items = [...counts].map(([id, qty]) => `${id}:${qty}`).join(',');
          wrap.dataset.items = items;
          wrap.classList.toggle('hidden', !items);
        });
      })
      .catch(() => {});
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wella-cart-share-action]');
    if (!button) return;
    const wrap = button.closest('[data-wella-cart-share]');
    const items = wrap?.dataset.items;
    if (!items) {
      toast('السلة فاضية، ضيفي قطعة الأول');
      return;
    }

    if (button.dataset.wellaCartShareAction === 'whatsapp') {
      const text = `${MESSAGE}\n${shareUrl(items, 'whatsapp')}`;
      const wa = `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`;
      if (window.matchMedia('(pointer: coarse)').matches) {
        location.href = wa;
      } else {
        const win = window.open(wa, '_blank');
        if (win) win.opener = null;
        else location.href = wa;
      }
      return;
    }

    const link = shareUrl(items, 'share');
    if (navigator.share) {
      navigator.share({ text: MESSAGE, url: link }).catch(() => {});
      return;
    }
    copyText(`${MESSAGE}\n${link}`).then(
      () => toast('اتنسخ اللينك 🤍 ابعتيه لأي حد'),
      () => toast(`انسخي اللينك ده وابعتيه:\n${link}`, 12000)
    );
  });

  /* ---------- offers meter (snippets/wella-offer-meter.liquid) ---------- */

  function refreshOfferMeter() {
    const targets = { 'wella-offer-meter': '[data-wella-offer-meter]', 'wella-offer-bar': '[data-wella-offer-bar]' };
    const ids = Object.keys(targets).filter((id) => document.querySelector(targets[id]));
    if (!ids.length) return;
    fetch(`${root}?sections=${ids.join(',')}`, { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((data) => {
        ids.forEach((id) => {
          const fresh = data[id] && new DOMParser().parseFromString(data[id], 'text/html').querySelector(targets[id]);
          if (!fresh) return;
          document.querySelectorAll(targets[id]).forEach((el) => el.replaceWith(fresh.cloneNode(true)));
          if (id === 'wella-offer-bar') {
            document.querySelectorAll('[data-wob-static]').forEach((el) => { el.hidden = !fresh.hidden; });
          }
        });
      })
      .catch(() => {});
  }

  function onCartChange() {
    refreshShareData();
    refreshOfferMeter();
  }

  document.addEventListener('cart:updated', onCartChange);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartChange);
  }

  /* ---------- recipient ---------- */

  function parseItems(code) {
    return code
      .split(',')
      .map((part) => part.split(':'))
      .filter(([id, qty]) => /^\d{1,20}$/.test(id || '') && /^\d{1,3}$/.test(qty || ''))
      .slice(0, MAX_LINES)
      .map(([id, qty]) => ({ id: Number(id), quantity: Math.min(Math.max(Number(qty), 1), MAX_QTY) }));
  }

  async function receive(code) {
    const params = new URLSearchParams(location.search);
    params.delete(PARAM);
    const cleanUrl = root + 'cart' + (params.toString() ? `?${params}` : '');
    const doneKey = `wella_ws_done_${code}`;

    if (safeSession.get(doneKey)) {
      location.replace(cleanUrl);
      return;
    }

    const overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;z-index:2147483001;background:rgba(255,255,255,.92);display:flex;align-items:center;justify-content:center;font-size:16px;direction:rtl;color:#222';
    overlay.textContent = 'بنجهزلك السلة… 🤍';
    document.body.appendChild(overlay);

    let added = 0;
    let failed = 0;
    for (const item of parseItems(code)) {
      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] }),
        });
        if (res.ok) added += 1;
        else failed += 1;
      } catch (e) {
        failed += 1;
      }
    }

    safeSession.set(doneKey, '1');
    safeSession.set(NOTICE_KEY, JSON.stringify({ added, failed }));
    location.replace(cleanUrl);
  }

  function showNotice() {
    const raw = safeSession.get(NOTICE_KEY);
    if (!raw) return;
    safeSession.remove(NOTICE_KEY);
    let notice;
    try { notice = JSON.parse(raw); } catch (e) { return; }
    if (notice.added && notice.failed) {
      toast('القطع اللي اتبعتتلك اتحطت في سلتك 🤍 وفيه قطعة خلصت أو مقاسها مش متاح دلوقتي', 7000);
    } else if (notice.added) {
      toast('القطع اللي اتبعتتلك اتحطت في سلتك 🤍', 5000);
    } else {
      toast('القطع اللي اتبعتتلك خلصت أو مقاساتها مش متاحة دلوقتي، شوفي الموديلات التانية 🤍', 7000);
    }
  }

  const incoming = new URLSearchParams(location.search).get(PARAM);
  if (incoming) {
    receive(incoming);
  } else {
    showNotice();
  }
})();
